import { render, staticRenderFns } from "./NovaSancao.vue?vue&type=template&id=bde52334"
import script from "./NovaSancao.vue?vue&type=script&lang=js"
export * from "./NovaSancao.vue?vue&type=script&lang=js"
import style0 from "./NovaSancao.vue?vue&type=style&index=0&id=bde52334&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports